import { render, staticRenderFns } from "./StepIdentity.vue?vue&type=template&id=e05c0478&"
import script from "./StepIdentity.vue?vue&type=script&lang=js&"
export * from "./StepIdentity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports